import { StateToken } from '@ngxs/store';
import { RemitosPrintStateModel as Model } from './remitos-print.state-model';

export const stateTokenName = new StateToken<Model>('production_remitos_print');
